import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import logo_worded_only from '../assets/logo_worded_only.png';
import { callApi, getCookie, setCookie } from "../Helpers";
import { MdArrowCircleRight, MdOutlinePhoneIphone, MdVpnKey } from "react-icons/md";
import {
  STR_CHANGE_LANGUAGE,
  STR_CONTINUE,
  STR_ENTER_PASSWORD,
  STR_ENTER_YOUR_PHONE_NUMBER,
  STR_FORGOT_PASSWORD,
  STR_INVALID_OTP,
  STR_INVALID_PASSWORD,
  STR_INVALID_PHONE,
  STR_PLEASE_WAIT,
  STR_RESEND_OTP,
  STR_WELCOME,
  STR_YOUR_PHONE,
  STR_YOUR_PASSWORD_VERIFICATION,
  STR_CHANGE_PHONE,
  STR_INTRO_2
} from "../Strings";

export default function Login(props) {
  const appContext = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [loginStep, setLoginStep] = useState("identity");

  async function init() {
    const storedPhone = getCookie("phone");
    const storedLoginStep = getCookie("loginStep");
    if (storedPhone) { setPhone(storedPhone); }
    if (storedLoginStep) { setLoginStep(storedLoginStep); }
  }

  // --- API LOGIC (Unchanged) ---
  async function resendOtp() {
    if (!loading) {
      if (String(phone).trim().length >= 9) {
        setLoading(true);
        await callApi("resend-otp", { phone: `255${parseInt(phone, 10)}`, identity: 'phone', email: '' }).then((response) => {
          if (response.status === 1) {
            setCookie('phone', phone);
            setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);
          } else { appContext.tellError(response.msg); }
        });
        setLoading(false);
      } else { appContext.tellError(STR_INVALID_PHONE[appContext.language]); }
    } else { appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]); }
  }

  async function phoneLogin() {
    if (!loading) {
      if (String(phone).trim().length >= 9) {
        setLoading(true);
        await callApi("phone-login", { phone: phone }).then((response) => {
          if (response.status === 1) {
            setCookie('phone', phone);
            setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);
          } else { appContext.tellError(response.msg); }
        });
        setLoading(false);
      } else { appContext.tellError(STR_INVALID_PHONE[appContext.language]); }
    } else { appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]); }
  }

  async function otpLogin() {
    if (!loading) {
      if (otp.trim().length === 6) {
        setLoading(true);
        await callApi("otp-login", { phone: `255${parseInt(phone, 10)}`, otp, identity: 'phone', email: '' }).then((response) => {
          if (response.status === 1) {
            setCookie('phone', ''); setCookie('loginStep', '');
            setCookie("userId", response.user.id); setCookie("userToken", response.user.token);
            appContext.navTo({ item: 'home' }); appContext.refresh();
            appContext.tellMessage(STR_WELCOME[appContext.language]);
          } else { appContext.tellError(response.msg); }
        });
        setLoading(false);
      } else { appContext.tellError(STR_INVALID_OTP[appContext.language]); }
    } else { appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]); }
  }

  
  async function passwordLogin() {
    if (!loading) {
      if (password.trim().length > 0) {
        setLoading(true);
        await callApi("password-login", { phone: phone, password }).then((response) => {
          if (response.status === 1) {
            setCookie('phone', ''); setCookie('loginStep', '');
            setCookie("userId", response.user.id); setCookie("userToken", response.user.token);
            appContext.navTo({ item: 'home' }); appContext.refresh();
            appContext.tellMessage(STR_WELCOME[appContext.language]);
          } else { appContext.tellError(response.msg); }
        });
        setLoading(false);
      } else { appContext.tellError(STR_INVALID_PASSWORD[appContext.language]); }
    } else { appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]); }
  }

  async function forgotPassword() {
    if (!loading) {
      if (String(phone).trim().length >= 9) {
        setLoading(true);
        await callApi("forgot-password", { phone: `255${parseInt(phone, 10)}`, email: '', identity: 'phone' }).then((response) => {
          if (response.status === 1) {
            setCookie('phone', phone); setCookie('loginStep', response.nextLoginStep);
            setLoginStep(response.nextLoginStep);
          } else { appContext.tellError(response.msg); }
        });
        setLoading(false);
      } else { appContext.tellError(STR_INVALID_PHONE[appContext.language]); }
    } else { appContext.tellInfo(STR_PLEASE_WAIT[appContext.language]); }
  }

  // --- REFACTORED DESIGN COMPONENTS ---

  function renderTopBrand() {
    return (
      <div style={{ paddingTop: "60px", paddingBottom: "40px", textAlign: "center" }}>
        
        <img
          src={logo_worded_only}
          alt="WATU Logo"
          style={{ width: "160px", height: "auto" }}
          className="mt-3"
        />
       
      </div>
    );
  }

  function renderShell(children) {
    return (
      <div style={{ width: "100%", minHeight: "100vh", background: "#020617", position: "relative", overflow: "hidden" }}>
        {/* Animated-like background depth */}
        <div style={{ position: "absolute", width: "140%", height: "60%", top: "-10%", left: "-20%", background: "radial-gradient(circle, rgba(16,185,129,0.15) 0%, transparent 70%)", borderRadius: "100%", pointerEvents: "none" }} />
        <div style={{ position: "absolute", width: "100%", height: "100%", bottom: "0", background: "linear-gradient(to top, #020617 30%, transparent 100%)", zIndex: 1 }} />
        
        <div className="container" style={{ position: "relative", zIndex: 10, padding: "0 24px" }}>
          {children}
        </div>
      </div>
    );
  }

  function renderInputWrapper(icon, children) {
    return (
      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        background: "rgba(255,255,255,0.03)", 
        border: "1px solid rgba(255,255,255,0.1)", 
        borderRadius: "16px", 
        padding: "4px 16px",
        marginBottom: "20px",
        transition: "all 0.3s ease"
      }}>
        <div style={{ color: "#10b981", marginRight: "12px", fontSize: "20px", display: "flex" }}>{icon}</div>
        {children}
      </div>
    );
  }

  function renderLinkItem(label, onClick, icon = true) {
    return (
      <div 
        onClick={onClick}
        style={{ 
          display: "flex", 
          alignItems: "center", 
          gap: "8px", 
          color: "rgba(255,255,255,0.5)", 
          fontSize: "14px", 
          fontWeight: "500",
          cursor: "pointer",
          padding: "8px 0",
          transition: "color 0.2s"
        }}
        onMouseEnter={(e) => e.currentTarget.style.color = "#10b981"}
        onMouseLeave={(e) => e.currentTarget.style.color = "rgba(255,255,255,0.5)"}
      >
        {icon && <MdArrowCircleRight size={18} />}
        {label}
      </div>
    );
  }

  useEffect(() => { init(); }, []);
  useEffect(() => { appContext.setShowOverlayLoader(loading); }, [loading]);

  return (
    <>{renderShell(
        <div style={{ maxWidth: "400px", margin: "0 auto" }}>
          {renderTopBrand()}

          <div style={{ textAlign: "center", marginBottom: "32px" }}>
            <h2 style={{ color: "#fff", fontSize: "22px", fontWeight: "700", marginBottom: "8px" }}>
              {loginStep === 'identity' ? `${STR_YOUR_PHONE[appContext.language]}!` : `${STR_YOUR_PASSWORD_VERIFICATION[appContext.language]}!`}
            </h2>
            <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "15px", lineHeight: "1.5" }}>
              {loginStep === 'identity' ? STR_ENTER_YOUR_PHONE_NUMBER[appContext.language] : STR_ENTER_PASSWORD[appContext.language]}
            </p>
          </div>

          {/* IDENTITY STEP */}
          {loginStep === 'identity' && (
            <div className="animate__animated animate__fadeInUp">
              {renderInputWrapper(<MdOutlinePhoneIphone />, 
                <>
                  <input
                    className="form-control-clean p-2 rounded-3"
                    onChange={(e) => { const val = e.target.value; if (!isNaN(val) || val === "") setPhone(val); }}
                    value={phone}
                    maxLength={10}
                    placeholder=""
                    style={{ background: "transparent", border: "1px solid white", color: "#fff", padding: "12px 0", width: "100%", outline: "none", fontSize: "16px", fontWeight: "600" }}
                  />
                </>
              )}

              <div style={{ marginTop: "24px" }}>
                <button
                  style={{ width: "100%", padding: "16px", borderRadius: "16px", border: "none", background: "#10b981", color: "#fff", fontWeight: "700", fontSize: "16px", boxShadow: "0 10px 20px -10px rgba(16,185,129,0.5)", cursor: "pointer" }}
                  onClick={() => phoneLogin()}
                >
                  {STR_CONTINUE[appContext.language]}
                </button>
              </div>

              <div style={{ marginTop: "32px", borderTop: "1px solid rgba(255,255,255,0.05)", paddingTop: "20px" }}>
                {renderLinkItem(STR_FORGOT_PASSWORD[appContext.language], () => forgotPassword())}
                {renderLinkItem(STR_CHANGE_LANGUAGE[appContext.language], () => appContext.changeLanguage())}
              </div>
            </div>
          )}

          {/* PASSWORD STEP */}
          {loginStep === 'password' && (
            <div className="animate__animated animate__fadeInUp">
              {renderInputWrapper(<MdVpnKey />, 
                <input
                  onChange={e => setPassword(e.target.value)}
                  type="password"
                  value={password}
                  style={{ background: "transparent", border: "none", color: "#fff", padding: "12px 0", width: "100%", outline: "none", fontSize: "20px", fontWeight: "800", textAlign: "center" }}
                />
              )}

              <div style={{ marginTop: "24px" }}>
                <button
                  style={{ width: "100%", padding: "16px", borderRadius: "16px", border: "none", background: "#10b981", color: "#fff", fontWeight: "700", fontSize: "16px", boxShadow: "0 10px 20px -10px rgba(16,185,129,0.5)", cursor: "pointer" }}
                  onClick={() => passwordLogin()}
                >
                  {STR_CONTINUE[appContext.language]}
                </button>
              </div>

              <div style={{ marginTop: "32px", borderTop: "1px solid rgba(255,255,255,0.05)", paddingTop: "20px" }}>
                {renderLinkItem(STR_CHANGE_PHONE[appContext.language], () => setLoginStep('identity'))}
                {renderLinkItem(STR_CHANGE_LANGUAGE[appContext.language], () => appContext.changeLanguage())}
              </div>
            </div>
          )}
          
          <footer style={{ marginTop: "60px", textAlign: "center", color: "rgba(255,255,255,0.2)", fontSize: "12px", fontWeight: "600", letterSpacing: "1px" }}>
            &copy; 2026 WATU GROUP • UMOJA NI NGUVU
          </footer>
        </div>
      )}</>
  );
}